import io from "socket.io-client";

// ─── Environment ────────────────────────────────────────────
// Change ENV to switch servers: "production" | "test" | "local"
const ENV = "production"; // "test" | "local" | "production"

const SERVERS = {
  production: {
    socket: "wss://socket.leon-gallery.com",
    api: "https://leon-gallery.com",
  },
  test: {
    socket: "http://157.230.43.47:3005",
    api: "http://157.230.43.47:8081",
  },
  local: {
    socket: "http://localhost:3005",
    api: "https://leon-gallery.com", // no local API defined before; points to production
  },
};

const server = SERVERS[ENV];

// ─── Socket ─────────────────────────────────────────────────
const SOCKET_OPTIONS = {
  transports: ["websocket", "polling"],
  reconnection: true,
  reconnectionAttempts: Infinity, // keep trying
  reconnectionDelay: 2000,
  reconnectionDelayMax: 5000,
  timeout: 10000,
  autoConnect: true,
  // Creates a new socket instance on every call, so the socket
  // reconnects properly after sleep and each time ChatSupportPage calls hostname()
  forceNew: true,
};

// `token` is accepted but not sent yet (auth is disabled).
// To enable it: add `auth: { token: token || null }` to the options.
export const hostname = (token) => io(server.socket, SOCKET_OPTIONS);

// ─── API ────────────────────────────────────────────────────
export const GetURL = server.api;

// ─── Feature flags ──────────────────────────────────────────
const buttonShow = false;

export const showButton = buttonShow === null || buttonShow === "true";